import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ISearchResult } from '@assetaccountant/core/models/search-result';
import { ISearchService } from '@assetaccountant/core/services/search.service';
import { of } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  standalone: false,
})
export class SearchBarComponent implements OnInit {
  @Input() placeholder: string;
  @Input() searchService: ISearchService;
  @Input() moreResultsLink: string;
  @Input() numberOfResults = 10;
  @Input() resultLink: (id, title) => string;

  @Output() onTyped = new EventEmitter();

  focused = false;
  results: ISearchResult[] = [];
  searchField: UntypedFormControl = new UntypedFormControl();

  get hasResults() {
    return this.results.length > 0;
  }

  constructor() {}

  ngOnInit() {
    this.searchField.valueChanges
      .pipe(
        debounceTime(200),
        distinctUntilChanged(),
        switchMap(searchCriteria => {
          if (searchCriteria) {
            return this.searchService.search({
              searchCriteria,
              numberOfResults: this.numberOfResults,
            });
          } else {
            return of({ results: [] });
          }
        }),
      )
      .subscribe(response => (this.results = response.results));
  }

  onBlur() {
    setTimeout(() => {
      this.focused = false;
    }, 200);
  }

  clear() {
    this.results = [];
    this.searchField.setValue(null);
  }
}
